import { Link } from 'react-router-dom';
import moment from 'moment';
import CountUp from 'react-countup';
import placeholderImage from '../../../assets/images/placeholder.jpg';
import { config } from '../../../config/index';
const { SERVER_URL } = config;

export const cardOptions = {
  chart: {
    height: 50,
    type: 'line',
    toolbar: { show: false },
    sparkline: {
      enabled: true,
    },
  },
  colors: ['#5156be'],
  stroke: {
    curve: 'smooth',
    width: 2,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    fixed: {
      enabled: false,
    },
    x: {
      show: false,
    },
    y: {
      title: {
        formatter: function (seriesName) {
          return '';
        },
      },
    },
    marker: {
      show: false,
    },
  },
};

export const performanceData = [
  {
    id: 1,
    associate_id: 112,
    associate_name: 'Jennie Sherlock',
    recent_observation: 'Lorem Ipsum',
    score: 82,
  },
  {
    id: 2,
    associate_id: 113,
    associate_name: 'Stacie Dub',
    recent_observation: 'Lorem Ipsum',
    score: 82,
  },
  {
    id: 3,
    associate_id: 114,
    associate_name: 'Ronald Tucker',
    recent_observation: 'Lorem Ipsum',
    score: 82,
  },
];

export const performanceColumns = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 0.3,
    sortable: true,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return <span className="fw-bold">{params.row?.id || '--'}</span>;
    },
  },
  {
    field: 'associate_name',
    headerName: 'Associate',
    flex: 1.5,
    sortable: true,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <Link
          className="associate-name fw-bold"
          state={params.row}
          to={`/performance-management/manage/${params.row?.id}`}
        >
          <img
            src={
              params.row?.image
                ? `${SERVER_URL}/${params.row?.image}`
                : placeholderImage
            }
            alt="default"
            className="rounded-circle border me-2"
            style={{ height: '30px', width: '30px' }}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = placeholderImage;
            }}
          />
          <span>{params.row?.associate_name || '--'}</span>
        </Link>
      );
    },
  },
  {
    field: 'recent_observation',
    headerName: 'Recent Observation',
    flex: 1.5,
    sortable: false,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="text-muted">
          {params.row?.recent_observation || '--'}
        </span>
      );
    },
  },
  {
    field: 'score',
    headerName: 'Score',
    flex: 0.5,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="badge associate-score p-2 px-4">
          <CountUp
            start={0}
            end={params.row?.score}
            duration={2}
            separator=""
          />
          <span>%</span>
        </span>
      );
    },
  },
];

export const evaluationData = [
  {
    id: 1,
    evaluation_date: '07/03/2025 11:12',
    observation: 'Lorem Ipsum',
    score: 82,
    evaluated_by: 'Evaluated by A',
  },
  {
    id: 2,
    evaluation_date: '07/03/2025 11:12',
    observation: 'Lorem Ipsum',
    score: 82,
    evaluated_by: 'Evaluated by B',
  },
  {
    id: 3,
    evaluation_date: '07/03/2025 11:12',
    observation: 'Lorem Ipsum',
    score: 82,
    evaluated_by: 'Evaluated by C',
  },
];

export const evaluationColumns = [
  {
    field: 'id',
    headerName: '#',
    flex: 0.4,
    sortable: true,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return <span className="fw-bold">{params.row?.id || '--'}</span>;
    },
  },
  {
    field: 'evaluation_date',
    headerName: 'Date of Evaluation',
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="text-muted">
          {params.row?.evaluation_date
            ? moment(params.row?.evaluation_date).format('DD-MM-YYYY')
            : '--'}
        </span>
      );
    },
  },
  {
    field: 'observation',
    headerName: 'Observation',
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="text-muted">{params.row?.observation || '--'}</span>
      );
    },
  },
  {
    field: 'score',
    headerName: 'Score',
    flex: 1,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="badge associate-score p-2 px-4">
          {params.row?.score ? (
            <>
              <CountUp
                start={0}
                end={params.row?.score}
                duration={2}
                separator=""
              />
              <span>%</span>
            </>
          ) : (
            '--'
          )}
        </span>
      );
    },
  },
  {
    field: 'evaluated_by',
    headerName: 'Evaluated by',
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <span className="text-muted">{params.row?.evaluated_by || '--'}</span>
      );
    },
  },
];

export const checklistData = [
  {
    checklist_id: 1,
    checklist: [
      {
        id: 1,
        question: 'Question 1',
        answer: 'Answer 1',
      },
      {
        id: 2,
        question: 'Question 2',
        answer: 'Answer 2',
      },
    ],
    date_created: '14/03/2024 11:06am',
  },
];

export const attendanceData = [
  {
    id: 1,
    time_in: '09:00',
    time_out: '18:00',
    punch_date: '14/03/2024 11:06am',
    location: 'Guoco Tower',
    status: 'On Time',
  },
];
